import {Injectable} from '@angular/core';

import {HttpClient, HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AllSidebarService {

  constructor(private http: HttpClient) {
  }

  getSidebarItems(url: string) {
    return this.http.get(url);
  }

  getSearchItem(url: string, itemName : string) {
    let params = new HttpParams();
    params = params.append('itemName', itemName);
    return this.http.get(url + '/item/item-name', {params:params});
  }
}
